import React from 'react';

import { useEffect } from 'react';
import { useUserIndexActions } from './UserIndexContext';
import UserIndexLoader from './UserIndexLoader';
import UsersTable from './UsersTable';
import Stack from '../../Shared/UI/Stack/components/Stack';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';

import styles from './Index.module.scss';

const Index = () => {
  const { initializeState } = useUserIndexActions();

  useEffect(() => {
    initializeState();
  }, []);

  return (
    <>
      <UserIndexLoader />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <PageTitle text="Users" />
          <UsersTable />
        </Stack>
      </div>
    </>
  );
};

export default Index;
